import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription, switchMap, tap } from 'rxjs';
import {
  otpSendActivateApi,
  otpVerifyActivateApi,
  otpVerifyResetApi,
  resetPasswordApi,
} from 'src/app/shared/constants/api.constants';
import { Toast } from 'src/app/shared/enums/toast';
import { ToastService, HttpBaseService } from '@evento-ng/libs';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-otp-verify',
  templateUrl: './otp-verify.component.html',
})
export class OtpVerifyComponent implements OnInit, OnDestroy {
  id: string;
  mobile: string;
  mobileRegionCode: string;
  code = new UntypedFormControl('');
  subs: Subscription[] = [];
  action: string;
  constructor(
    private route: ActivatedRoute,
    private dataService: HttpBaseService,
    private toast: ToastService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.subs.push(
      this.route.queryParams
        .pipe(
          tap((res) => {
            this.id = res.id;
            this.mobile = res.mobile;
            this.mobileRegionCode = res.mobileRegionCode;
            this.action = res.action;
          })
        )
        .subscribe()
    );
  }

  verifyCode(): void {
    this.spinner.show();
    this.recaptchaV3Service
      .execute('otpVerifyApi')
      .pipe(
        switchMap((token) => {
          return this.dataService.post(
            `${
              this.action == 'reset' ? otpVerifyResetApi : otpVerifyActivateApi
            }`,
            {
              id: this.id,
              code: this.code.value,
              mobile: this.mobile,
              mobileRegionCode: this.mobileRegionCode,
              recaptcha: token,
            }
          );
        }),
        tap((_) => {
          this.spinner.hide();
          this.router.navigateByUrl('/auth/login');
          this.action == 'reset'
            ? this.router.navigateByUrl('auth/change-password/' + _.message)
            : this.toast.show(
                'Success',
                this.translate.instant('Activation code has been verified'),
                {
                  classname: Toast.success,
                }
              );
        })
      )
      .subscribe();
  }

  resendActivationCode(): void {
    this.spinner.show();
    this.recaptchaV3Service
      .execute('otpResendApi')
      .pipe(
        switchMap((token) => {
          return this.dataService.post(
            `${this.action == 'reset' ? resetPasswordApi : otpSendActivateApi}`,
            {
              mobile: this.mobile,
              mobileRegionCode: this.mobileRegionCode,
              recaptcha: token,
            }
          );
        }),
        tap((_) => {
          this.spinner.hide();
          this.toast.show(
            'Success',
            this.translate.instant('Activation code has been sent'),
            {
              classname: Toast.success,
            }
          );
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
